import { Button, cn, ghostAccentIconTileClass } from '@up2stay/up2promo-ui';
import { Package, X } from 'lucide-react';

export interface ProductHashChipProps {
  hash: string;
  onRemove?: (index: number) => void;
  index?: number;
  removeAriaLabel?: string;
}

/**
 * Displays a product hash (code) with Package icon.
 * Optionally shows a remove button when onRemove is provided (e.g. setup wizard list).
 */
export function ProductHashChip({
  hash,
  onRemove,
  index = 0,
  removeAriaLabel,
}: ProductHashChipProps) {
  return (
    <div className="flex items-center gap-2 rounded-[11px] border border-border bg-muted/40 px-3 py-2">
      <span
        className={cn(
          'grid size-7 shrink-0 place-items-center rounded-[9px]',
          ghostAccentIconTileClass,
        )}
        aria-hidden
      >
        <Package className="size-3.5" />
      </span>
      <span className="min-w-0 flex-1 font-mono text-[13.5px] leading-relaxed">
        {hash}
      </span>
      {onRemove != null && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-8 w-8 shrink-0"
          onClick={() => onRemove(index)}
          aria-label={removeAriaLabel}
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
